export enum ContainerValidated {
  UNCHECKED,
  VALIDATED,
  LOADING,
  ERROR,
  INACTIVE,
}

export type GetContainerResponse = {
  container: CmsContainer;
  containerDefinition: ContainerDefinition;
};

export type ContainerDefinition = {
  containerType: string;
};

export type CmsContainer = {
  containerId: string;
  containerName: string;
  isActive: boolean;
};

export type GetPartsResponse = {
  totalResults: number;
  parts: MobilityPart[];
};

export type GetBinResponse = {
  id: number;
  bin: string;
  bin_type_id: number;
  cms_id: string;
};

export interface MobilityPart {
  serialId?: string;
  model: string;
  vendor: string;
  type: string;
  state: string;
  serial_id?: string;
}

export interface Part {
  response: string;
  serialId: string;
  location: string;
  action: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  confirmFunction?: any;
}
